import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <span
    className={`font-mono text-xs uppercase tracking-[0.22em] inline-flex items-center gap-2 ${
      light ? "text-slate-300" : "text-slate-600"
    }`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-[var(--cobalt)]" />
    {children}
  </span>
);

export const Logo = ({ light = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
    <svg viewBox="0 0 64 64" className="h-9 w-9" aria-hidden="true">
      <rect width="64" height="64" rx="16" fill={light ? "#FFFFFF" : "#0B1220"} />
      <path d="M16 18h9l7 18 7-18h9L36.5 46h-9z" fill={light ? "#0B1220" : "#FFFFFF"} />
      <rect x="14" y="50" width="36" height="4" rx="2" fill="#2453FF" />
      <circle cx="48" cy="16" r="4" fill="#12B886" />
    </svg>
    <span className={`font-display text-xl font-semibold tracking-tight ${light ? "text-white" : "text-[var(--ink)]"}`}>
      Vectis<span className="text-[var(--cobalt)]">.</span>
    </span>
  </span>
);
